import React, { useEffect, useState } from 'react';

import './privacy-policy.css'

const PrivacyPolicy = () => {

    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>

            <div className='home-container'>
                <div className='privacy-titles'>
                    <div className='privacy-heading'>
                        <p>Privacy Policy</p>
                        <p>Midtown Medical Pharmacy</p>
                        <p>Last Updated: February 15, 2026</p>
                    </div>
                </div>


                <div className='privacy-content'>
                    <hr id='privacy-line'></hr>

                    <h2>1. Our Commitment to Your Privacy</h2>
                    <p>Midtown Medical Pharmacy (“Midtown,” “we,” “us,” or “our”) is committed to protecting the privacy and confidentiality of your personal information and personal health information. <br></br><br></br>
                        Midtown Medical Pharmacy is a Health Information Custodian under Ontario’s Personal Health Information Protection Act, 2004 (“PHIPA”). We collect, use, and disclose personal health information in accordance with PHIPA and other applicable Canadian privacy laws.
                    </p>

                    <hr id='privacy-line'></hr>

                    <h2>2. What Information We Collect</h2>
                    <p>We collect information necessary to provide pharmacy services and comply with legal and regulatory requirements.</p>
                    <br></br>
                    <h4>A. Personal Health Information (PHI)</h4>
                    <p>This may include:</p>
                    <ul>
                        <li>Your name, address, telephone number, and email address</li>
                        <li>Date of birth and gender</li>
                        <li>Ontario Health Card number</li>
                        <li>Prescription records and medication history</li>
                        <li>Drug allergies and medical conditions</li>
                        <li>Clinical notes and medication review documentation</li>
                        <li>Prescriber information</li>
                        <li>Insurance and billing information</li>
                    </ul>

                    <hr id='privacy-line'></hr>

                    <h4>B. Personal Information (Non-Health)</h4>
                    <p>We may collect:</p>
                    <ul>
                        <li>Payment information</li>
                        <li>General inquiries submitted by phone or email</li>
                        <li>Contact details for non-clinical communication</li>
                    </ul>

                    <hr id='privacy-line'></hr>

                    <h2>3. How We Collect Information</h2>
                    <p>We collect information directly from you when you:</p>
                    <ul>
                        <li>Present a prescription</li>
                        <li>We transfer a prescription</li>
                        <li>Receive a consultation</li>
                        <li>Receive vaccinations or clinical services</li>
                        <li>Communicate with us by phone or email</li>
                        <li>Provide insurance or billing information</li>
                    </ul>

                    <br></br>

                    <p>We may also collect information from:</p>
                    <ul>
                        <li>Your physician or other healthcare providers</li>
                        <li>Hospitals or clinics</li>
                        <li>Insurance providers</li>
                        <li>The Ontario Ministry of Health</li>
                    </ul>

                    <hr id='privacy-line'></hr>

                    <h2>4. Why We Collect and Use Your Information</h2>
                    <p>We collect, use, and disclose your information for the following purposes:</p>
                    <ul>
                        <li>To dispense prescriptions</li>
                        <li>To provide medication counselling and clinical services</li>
                        <li>To conduct medication reviews</li>
                        <li>To administer vaccinations</li>
                        <li>To communicate with prescribers</li>
                        <li>To submit claims to public and private insurers</li>
                        <li>To comply with legal and regulatory requirements</li>
                        <li>To maintain accurate pharmacy records</li>
                        <li>To improve patient care and safety</li>
                    </ul>
                    <br></br>

                    <p>We collect only the information necessary to provide these services.</p>

                    <hr id='privacy-line'></hr>

                    <h2>5. How We Share Information</h2>
                    <p>We may disclose personal health information where permitted or required by law, including:</p>
                    <ul>
                        <li>To prescribers and other healthcare providers</li>
                        <li>To public and private insurers</li>
                        <li>To regulatory authorities</li>
                        <li>To public health authorities when required</li>
                        <li>To service providers who assist in operating the pharmacy (e.g., pharmacy software providers), subject to confidentiality safeguards</li>
                    </ul>
                    <br></br>

                    <p>We do <b>not sell personal information or personal health information.</b></p>

                    <hr id='privacy-line'></hr>

                    <h2>6. Website and Online Communications</h2>
                    <p>Our website does not allow prescription submissions or account creation.</p>
                    <p>The website only provides general pharmacy information and a contact option by phone or email.</p>
                    <p>If you contact us by email, please do not include highly sensitive health information unless necessary. Email communications may not be fully secure.</p>

                    <hr id='privacy-line'></hr>

                    <h2>7. Consent</h2>
                    <p>Under PHIPA, we generally rely on implied consent to collect, use, and disclose personal health information for the purpose of providing healthcare services.</p>
                    <p>You may withdraw consent at any time, subject to legal and regulatory limitations.</p>

                    <hr id='privacy-line'></hr>

                    <h2>8. Safeguards</h2>
                    <p>We take reasonable administrative, technical, and physical safeguards to protect personal information, including:</p>
                    <ul>
                        <li>Secure pharmacy software systems</li>
                        <li>Password-protected electronic records</li>
                        <li>Restricted staff access</li>
                        <li>Locked filing systems</li>
                        <li>Staff confidentiality training</li>
                    </ul>

                    <hr id='privacy-line'></hr>

                    <h2>9. Retention of Records</h2>
                    <p>We retain pharmacy records in accordance with applicable laws and professional standards, including:</p>
                    <ul>
                        <li>A minimum of 10 years from the date of the last entry in the record</li>
                        <li>For minors, at least 10 years after the individual reaches 18 years of age</li>
                    </ul>

                    <br></br>

                    <p>Records are securely destroyed when no longer required.</p>

                    <hr id='privacy-line'></hr>

                    <h2>10. Your Rights </h2>
                    <p>Under PHIPA, you have the right to:</p>
                    <ul>
                        <li>Request access to your personal health information</li>
                        <li>Request correction of inaccurate information</li>
                        <li>Withdraw consent (where applicable)</li>
                        <li>Make a complaint regarding privacy practices</li>
                    </ul>

                    <br></br>

                    <p>Requests must be made in writing and may require identity verification.</p>

                    <hr id='privacy-line'></hr>

                    <h2>11. Privacy Officer</h2>
                    <p>Midtown Medical Pharmacy has designated a Privacy Officer responsible for compliance with PHIPA.</p>
                    <p>If you have questions or concerns about our privacy practices, please contact:</p>
                    <br></br>
                    <p><b>Privacy Officer</b></p>
                    <p>Midtown Medical Pharmacy</p>
                    <p>130 Wilson St</p>
                    <p>Hamilton, ON L8R 1E2</p>
                    <p>Phone: 905-557-4000</p>
                    <p>Email: mtmedicalpharmacy@gmail.com</p>
                </div>
            </div>
        </>

    )

};

export default PrivacyPolicy;